class CartItems extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('[data-id]');

    this.addEventListener('click', (event) => {
      const quantityButton = event.target.closest('[data-quantity-change]');
      if (quantityButton) this.onQuantityChange(quantityButton);
    });
  }

  onQuantityChange(button) {
    const item = button.closest('[data-cart-item]');
    if (!item) return;

    const key = item.dataset.lineItemKey;
    const valueEl = item.querySelector('[data-quantity-value]');
    const currentQuantity = parseInt(valueEl?.textContent ?? '0', 10);

    let newQuantity;
    if (button.dataset.quantityChange === 'remove') {
      newQuantity = 0;
    } else {
      newQuantity = currentQuantity + parseInt(button.dataset.quantityChange, 10);
      if (newQuantity < 1) return;
    }

    this.updateItem(key, newQuantity, item);
  }

  updateItem(key, quantity, itemEl) {
    itemEl?.classList.add('cart-item--loading');
    itemEl?.querySelectorAll('button').forEach((button) => {
      button.disabled = true;
    });

    const footer = document.getElementById('main-cart-footer');

    fetch(this.dataset.cartChangeUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: key,
        quantity,
        sections: [this.container?.dataset.id, footer?.dataset.id, 'cart-icon-bubble', 'cart-live-region-text', 'cart-drawer'].filter(
          Boolean
        ),
        sections_url: window.location.pathname,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (!data.sections) return;

        this.updateSection(this.container, data.sections);
        this.updateSection(footer, data.sections);
        CartDrawer.updateSections(data.sections);
        document.querySelector('cart-drawer')?.updateContent(data.sections);

        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: data });
      })
      .catch((error) => {
        console.error(error);
        itemEl?.classList.remove('cart-item--loading');
        itemEl?.querySelectorAll('button').forEach((button) => {
          button.disabled = false;
        });
      });
  }

  updateSection(target, sections) {
    const id = target?.dataset.id;
    if (!id || !sections[id]) return;

    const parsed = new DOMParser().parseFromString(sections[id], 'text/html');
    const newTarget = parsed.getElementById(target.id);
    if (newTarget) target.innerHTML = newTarget.innerHTML;
  }
}

customElements.define('cart-items', CartItems);
